<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Kod</label>
            <input v-model="value.Code" placeholder="Kod" class="form-control"/>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Grup Adı</label>
            <input v-model="value.Name" placeholder="Grup Adı" class="form-control"/>
        </div>
        <div class="col-12 mb-1">
            <table class="table table-sm table-bordered">
                <tr v-for="(b,i) in value.Branches">
                    <td class="p-25">
                        <button :disabled="(value.Branches || []).length == 1" v-on:click="$delete(value.Branches,i)" class="btn btn-sm btn-icon btn-outline-danger">
                            <feather-icon icon="TrashIcon"></feather-icon>
                        </button>
                    </td>
                    <td class="w-100 p-25">
                        <v-select-list class="mb-25" :options="c_branches" v-model="value.Branches[i].Branch" label="Name" placeholder="Şube"></v-select-list>
                        <v-select-list multiple :options="collarStatuses" v-model="value.Branches[i].CollarStatus" label="Name" placeholder="Yaka"></v-select-list>
                    </td>
                </tr>
                <tr>
                    <td colspan="3" class="p-25">
                        <button class="btn btn-outline-secondary btn-sm w-100" v-on:click="add">Ekle</button>
                    </td>
                </tr>
                <tr>
                    <th colspan="2" class="bg-light">Hariçler</th>
                </tr>
                <tr v-if="value.ExcludedBranches.length == 0">
                    <td colspan="3" class="text-center">Hariç tutulan bulunmamaktadır.</td>
                </tr>
                <tr v-for="(b,i) in value.ExcludedBranches">
                    <td class="p-25">
                        <button :disabled="(value.ExcludedBranches || []).length == 1" v-on:click="$delete(value.ExcludedBranches,i)" class="btn btn-sm btn-icon btn-outline-danger">
                            <feather-icon icon="TrashIcon"></feather-icon>
                        </button>
                    </td>
                    <td class="w-100 p-25">
                        <v-select-list class="mb-25" :options="c_exbranches" v-model="value.ExcludedBranches[i].Branch" label="Name" placeholder="Şube"></v-select-list>
                        <v-select-list multiple :options="collarStatuses" v-model="value.ExcludedBranches[i].CollarStatus" label="Name" placeholder="Yaka"></v-select-list>
                    </td>
                </tr>
                <tr>
                    <td colspan="3" class="p-25">
                        <button class="btn btn-outline-secondary btn-sm w-100" v-on:click="addEx">Ekle</button>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import CompanyApi from '@/api/company'
import SystemDataApi from '@/api/system-data'

export default {
    props:{
        value:Object
    },
    data(){
        return {
            collarStatuses:[],
            branches:[]
        }
    },
    mounted(){
        this.getBranches()
        this.getCollarStatuses()
    },
    methods:{
        getBranches(){
            CompanyApi.Branch.List().then(res=>{
                this.branches = res.data.Data
            })
        },
        getCollarStatuses(){
            SystemDataApi.CollarStatus().then(res => {
                this.collarStatuses = res.data.Data
            })
        },
        add(){
            this.value.Branches.push({Branch:null,CollarStatus:null})
        },
        addEx(){
            this.value.ExcludedBranches.push({Branch:null,CollarStatus:null})
        }
    },
    computed:{
        c_branches(){
            return this.branches.filter(b => !this.value?.Branches.map(b => b.Branch?.Id || null).includes(b.Id))
        },
        c_exbranches(){
            return this.branches.filter(b => !this.value?.ExcludedBranches.map(b => b.Branch?.Id || null).includes(b.Id))
        }
    }
}
</script>